import { RouteComponentProps } from "@reach/router";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import BigSlides from "../Components/BigSlides";
// import Button from "../Components/Button";
// import EventPlansSection from "../Components/EventPlans";
// import EventRundown from "../Components/EventRundown";
import EventSpeakers from "../Components/EventSpeakers";
// import EventSponsors from "../Components/EventSponsors";
import Layout from "../Components/Layout";
// import Testimonials from "../Components/Testimonials";
import { useSelector } from "react-redux";
import WhatsAbout from "../Components/WhatsAbout";
import { useWithLang } from "../i18n";
// import Printicon from "../icons/PrintIcon";
import { RootState } from "../stores";
import { ApiResponse } from "../utils/api";
import { SettingProp } from "../utils/types";
// import InfoLomba from "../Components/InfoLomba";
// import Expo from "../Components/Expo";
// import BigSlidesIBD from "../Components/IDB/BigSlidesIBD";
// import Dokumentasi from "../Components/IDB/Dokumentasi";
// import Figures from "../Components/IDB/Figures";
// import InfoIBD from "../Components/IDB/InfoIBD";
// import Video from "../Components/IDB/Video";

interface Props extends RouteComponentProps {}

const IndexPage = (props: Props) => {
  const sliderRef = useRef();
  const { t } = useTranslation();
  const { f } = useWithLang();
  const { isLogin } = useSelector((state: RootState) => state.user);
  const url_register = isLogin ? "/register-event" : "https://s.id/form-ibd";

  const { data: bookSeat } = useSWR<ApiResponse<SettingProp>>(
    f("/public/pages/book-seat"),
    {
      initialData: null,
    }
  );

  return (
    <Layout transparent lightAfter={sliderRef}>
      <section className="mb-8">
        <BigSlides compRef={sliderRef} />
      </section>
      <section className="my-10 md:my-20 container mx-auto">
        <WhatsAbout />
      </section>
      <section className="py-10 mb-10 bg-gray-100">
        <div className="container mx-auto">
          <div className="flex items-center">
            <h2 className="text-3xl font-semibold font-sans">
              {t("Siapa saja yang akan hadir ?")}
            </h2>
          </div>
          <div className="content mt-3 font-sans text-lg text-justify">
            <p className="mb-4">
              Forum ini terbuka untuk seluruh pemangku kepentingan yang berperan
              dalam pengembangan ekosistem digital Indonesia, di antaranya:
            </p>
            <ol>
              <li>
                1. Pejabat pemerintah dan regulator di bidang komunikasi,
                teknologi, dan transformasi digital
              </li>
              <li>
                2. Pelaku industri digital, penyelenggara internet, dan
                perusahaan teknologi
              </li>
              <li>
                3. Akademisi, peneliti, dan pakar di bidang teknologi informasi
                dan kebijakan digital
              </li>
              <li>
                4. Komunitas digital, pegiat teknologi, dan startup digital
              </li>
              <li>5. Asosiasi dan organisasi profesi di sektor TIK</li>
              <li>6. Media teknologi dan jurnalis kebijakan digital</li>
              <li>
                7. Generasi muda digital savvy yang ingin berkontribusi dalam
                transformasi digital nasional
              </li>
            </ol>
          </div>
        </div>
      </section>
      <section className="py-10 mb-10">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row mb-8">
            <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0">
              <div className="flex items-center">
                <h2 className="text-3xl font-semibold font-sans">
                  {t("VISI")}
                </h2>
              </div>
              <div className="content mt-3 font-sans text-lg text-justify">
                Terciptanya Kolaborasi dan Sinergi Ekosistem Digital Menuju
                Indonesia Emas 2045.
              </div>
            </div>
            <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0 ml-3">
              <div className="flex items-center">
                <h2 className="text-3xl font-semibold font-sans">
                  {t("MISI")}
                </h2>
              </div>
              <div className="content mt-3 font-sans text-lg text-justify">
                <ol type="1">
                  <li>
                    1. Menyediakan wadah komunikasi dan diskusi para pelaku
                    industri digital di tingkat nasional.
                  </li>
                  <li>
                    2. Membahas isu - isu pembangunan ekosistem digital dalam
                    rangka menyusun strategi digital nasional.
                  </li>
                  <li>
                    3. Menghasilkan suatu kerangka rekomendasi dan prioritas
                    nasional untuk mendorong kolaborasi dan sinergi para pelaku
                    industri digital nasional.
                  </li>
                  <li>
                    4. Memperkuat komitmen bersama dalam hal kolaborasi dan
                    sinergi ekosistem digital nasional.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pb-10">
        <EventSpeakers />
      </section>
      <div className="flex flex-col md:flex-row h-1 bg-black container mx-auto"></div>
      <section className="py-10 mb-10 mt-5">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row mb-8">
            <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0">
              <div className="flex items-center ml-4">
                <h2 className="text-3xl font-semibold font-sans">
                  {t("Host")}
                </h2>
              </div>
              <div className="content mt-8 font-sans text-lg text-justify flex items-center">
                <img
                  src="/images/logo-pandi-color.png"
                  alt="Express Freedom"
                  className="h-10 md:h-16 mb-3"
                />
                <img
                  src="/images/apji.png"
                  alt={t("Home")}
                  className="ml-3 h-10 md:h-24 bg-transparent"
                />
              </div>
            </div>
            <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0 ml-3">
              <div className="flex items-center ml-6">
                <h2 className="text-3xl font-semibold font-sans">
                  {t("Co-Host")}
                </h2>
              </div>
              <div className="content mt-8 font-sans text-lg text-justify">
                <img
                  src="/images/atsi.png"
                  alt={t("Home")}
                  className="ml-3 h-10 md:h-24 bg-transparent"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="my-5 md:my-10 container mx-auto">
        <Video />
      </section> */}
      {/* <section className="my-5 md:my-10 container mx-auto">
        <InfoLomba />
        <InfoIBD />
      </section> */}
      {/* <section className="my-5 md:my-10 container mx-auto">
        <Expo />
      </section> */}
      {/* <section>
        <Figures />
      </section> */}
      {/* <div className="bg-gray-200 pt-4 -mt-10">
        <section className="pb-10">
          <EventSpeakers />
        </section>
        <section className="my-10 container mx-auto hidden">
          <div className="flex items-center flex-col md:flex-row">
            <div className="flex-1 flex w-full md:w-auto items-center mb-6 md:mb-0">
              <div className="mr-3">
                <img
                  src="/images/pandi.png"
                  className="w-14 md:w-auto"
                  alt="pandi id logo"
                />
              </div>

              <h2 className="text-xl md:text-3xl font-semibold font-sans">
                {t("RUNDOWN EVENT")}
              </h2>
            </div>
            <div className="w-full md:w-auto flex justify-end">
              <Button
                size="md"
                className="flex items-center font-sans md:text-xl font-semibold bg-white"
                color="secondary"
                onClick={() => {
                  window.open(
                    process.env.REACT_APP_BASE_URL + "/public/events/download",
                    "_blank"
                  );
                }}
                outline>
                <Printicon className="mr-2 w-6 h-6" />
                {t("Download Schedule")}
              </Button>
            </div>
          </div>
        </section>
        <div className="container mx-auto mb-8">
          {isLogin && (
            <Link to="/register-event">
              <Button color="primary" className="font-sans">
                {t("REGISTER EVENT")}
              </Button>
            </Link>
          )}
        </div>

        <section className="mb-8 container mx-auto">
          <EventRundown />
        </section>

        <section className="hidden">
          <EventPlansSection />
        </section>

        <section className="">
          <EventSponsors />
        </section>

        <section className="hidden">
          <Testimonials />
        </section>

        <section className="border border-t">
          <Dokumentasi />
        </section>

        <section className="mx-auto hidden">
          <div
            className="flex flex-col items-center py-16 px-8 text-center text-white"
            style={{
              background: "#1A1438",
            }}>
            <h1 className="text-3xl font-bold">{t("BOOK YOUR SEAT")}</h1>
            <p className="mt-4" style={{ maxWidth: 600 }}>
              {bookSeat?.data?.value}
            </p>
            <div className="mt-4">
              {isLogin ? (
                <Link to={url_register}>
                  {" "}
                  <Button
                    className="mx-2 mb-4 md:text-2xl font-sans"
                    color="primary">
                    {t("REGISTER")}
                  </Button>
                </Link>
              ) : (
                <a href={url_register}>
                  <Button
                    className="mx-2 mb-4 md:text-2xl font-sans"
                    color="primary">
                    {t("REGISTER")}
                  </Button>
                </a>
              )}
            </div>
          </div>
        </section>
      </div> */}
    </Layout>
  );
};

export default IndexPage;
